import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Shows only liters in order creation unit of admixtures
 */
@Injectable()
export class CashOrderBlkAdt implements IFlagFeature {
  name = Features.CASH_ORDER_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
